import { useMemo, useState, useEffect } from "react";
import API from "./helpers/api";
import { useDispatch } from "react-redux";
import {Container, Row, Col, Card, Form} from 'react-bootstrap';
import { use } from "react";
import { useNavigate } from "react-router-dom";
function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const api = useMemo(() => new API({dispatch}), [dispatch]);
  
  const [user, setUser] = useState(() => ({
    email: '',
    user_password: ''
  }));

  useEffect(() => {
     const checkAuth = async () => {
       const isAuthenticated = await api.checkAuth();
       if (isAuthenticated) {
         navigate('/customers');
       }
     };
     checkAuth();
  }, [api, navigate]);

  const login = async (e) => {
    e.preventDefault();
    try {
      await api.signIn(user);
      navigate('/customers');
    } catch (error) {
      alert('Login failed. Please check your credentials.');
    }
  }
  return (
    <Container className="mt-5">
       <Card bg="dark" text="white">
          <Card.Header><h5>TCC Support Tool</h5></Card.Header>
          <Card.Body>

            <h4 className="text-center">Login</h4>
            <hr />
             <Form onSubmit={login}>
                <Form.Group as={Row} className="mb-3" controlId="formEmail">
                   <Form.Label column sm={2}>Email</Form.Label>
                   <Col sm={10}>
                      <Form.Control 
                         type="email" 
                         placeholder="Enter email" 
                         value={user.email}
                         onChange={(e) => setUser({...user, email: e.target.value})}
                         required 
                      />
                   </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="formPassword">
                   <Form.Label column sm={2}>Password</Form.Label>
                   <Col sm={10}>
                      <Form.Control 
                         type="password" 
                         placeholder="Password" 
                         value={user.user_password}
                         onChange={(e) => setUser({...user, user_password: e.target.value})}
                         required 
                      />
                   </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                   <Col sm={{ span: 10, offset: 2 }}>
                      <button type="submit" className="btn btn-primary">Sign In</button>
                   </Col>
                </Form.Group>

             </Form>
          </Card.Body>
       </Card>
    </Container>
  );
}

export default App;
